
import { getActiveRestaurantId, getActiveRestaurantSystemId } from "@/lib/idProvider";

function useAuth(){
    const user = JSON.parse(localStorage.getItem("user") || "null");
    const resolvedRestaurantId = getActiveRestaurantId();
    const resolvedRestaurantSystemId = getActiveRestaurantSystemId();

    if(user === undefined || user === null){
        return({
            status: false,
            restaurant_id: resolvedRestaurantId,
            restaurant_system_id: resolvedRestaurantSystemId,
        });
    }else{
        if(user?.id !== ""){
            return({
                status: true, 
                user: {
                    ...user,
                    restaurant_id: user?.restaurant_id || resolvedRestaurantId,
                    restaurant_system_id: user?.restaurant_system_id || resolvedRestaurantSystemId,
                },
                restaurant_id: resolvedRestaurantId,
                restaurant_system_id: resolvedRestaurantSystemId,
            });
        }else{
            return({
                status: false,
                restaurant_id: resolvedRestaurantId,
                restaurant_system_id: resolvedRestaurantSystemId,
            });
        }
    }
}

export default useAuth;